var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebookWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 153,
    height: 153,
    viewBox: "0 0 153 153",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(0 -0.011)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 76.5,
    cy: 76.5,
    r: 76.5,
    transform: "translate(0 0.011)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(49.877 30.643)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M71.307.019,59.037,0C45.252,0,36.343,8.895,36.343,22.661V33.11H24.006a1.9,1.9,0,0,0-1.929,1.879V50.127A1.9,1.9,0,0,0,24.006,52H36.343V90.2a1.9,1.9,0,0,0,1.929,1.878h16.1A1.9,1.9,0,0,0,56.3,90.2V52H70.723a1.9,1.9,0,0,0,1.929-1.878l.006-15.139a1.855,1.855,0,0,0-.565-1.328,1.957,1.957,0,0,0-1.365-.551H56.3V24.252c0-4.257,1.042-6.418,6.741-6.418l8.266,0a1.9,1.9,0,0,0,1.928-1.878V1.9A1.9,1.9,0,0,0,71.307.019Z",
    transform: "translate(-22.077)",
    fill: "#273c49"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookWhite);
export default __webpack_public_path__ + "static/media/facebook-white.83ca03a63fa138423ea00a05b5b07afe.svg";
export { ForwardRef as ReactComponent };